import React, { useCallback, useEffect, useRef, useState } from "react";
import BasicTable from "../../../../Components/CommonTable/BasicTable/BasicTable";
import { useFetchAll } from "../../../../custom/FetchApiHook.jsx";
import { ParcelCategoryApi } from "../../../../App/api/ParcelCategory.api";
import { Columns, searchBy, filters } from "../../../../service/ParcelCategoryService";
import AddParcelCategory from "./AddParcelCategory";
import CommonLayout from "../../../../Components/CommonLayout/CommonLayout";
import { toast } from "react-toastify";

function ParcelCategory({ meta }) {
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 5,
    sortOrder: "desc",
    filter: {},
  });
  const [search, setSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const debounceTimeout = useRef(null);

  const fetchFunc = useCallback(() => 
    ParcelCategoryApi.getAllParcelCategoriesWithPagination(pagination, search), 
    [pagination, search]
  );

  const { value, fetchAllData } = useFetchAll(fetchFunc);

  const handlePagination = (data) => {
    if (data.clearPagination) {
      setPagination(data.clearPagination);
      return;
    }

    setPagination((prev) => {
      let copyfilter = { ...prev.filter };

      if (data.filter) {
        if (copyfilter[Object.keys(data.filter)[0]]) {
          copyfilter[Object.keys(data.filter)[0]] = Object.values(data.filter)[0];
        } else {
          copyfilter = { ...data?.filter, ...copyfilter };
        }
      }

      return {
        page: data.page ? data.page : prev.page,
        limit: data.limit ? data.limit : prev.limit,
        sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
        filter: copyfilter,
      };
    });
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleRowClick = (row) => {
    setSelectedCategory(row);
    setAddModalOpen(true);
  };

  const handleClose = () => {
    setAddModalOpen(false);
    setSelectedCategory(null);
  };

  const tableData = value?.data?.parcelCategories || [];

  return (
    <>
      <CommonLayout />
      <div className="flex w-full justify-between flex-wrap p-[2rem]">
        <div>
          <p className="text-[1.3rem] text-[--text-color3] capitalize">Parcel Category Fees</p>
          <span className="text-[0.9rem] text-[--color-tbl-data] ml-3">
            Manage parcel category pricing and allowed vehicles.
          </span>
        </div>
      </div>

      <div className="p-5">
        <BasicTable
          columns={Columns}
          data={tableData}
          onPaginatorClick={(e) => {
            if (e) {
              handlePagination({ limit: e.rows, page: +e.page + 1 });
            }
          }}
          paginatorData={{
            filters: null,
            first: 0,
            multiSortMeta: [],
            page: value?.data?.page || 1,
            rows: value?.data?.limit || 5,
            sortField: null,
            sortOrder: null,
            totalPages: value?.data?.totalPages || 1,
            totalCount: value?.data?.totalCount || 0,
          }}
          handleSearch={debouncedSearch}
          SearchBy={searchBy}
          handleFilter={(name, value) => {
            let data = {};
            if (name === "search_by") {
              data.sortOrder = value.code;
            } else {
              const filter = {};
              filter[name] = value.code ? value.code : value;
              data.filter = filter;
            }
            handlePagination(data);
          }}
          handleClearFilter={() => {
            handlePagination({
              clearPagination: {
                page: 1,
                limit: 5,
                sortOrder: "desc",
                filter: {},
              },
            });
            toast.info("Filters cleared successfully!");
          }}
          filters={filters}
          selectedData={selectedCategory}
          handleRowClick={handleRowClick}
          button_name="Add Parcel Category"
          handleButton={() => setAddModalOpen(true)}
        />
      </div>

      {addModalOpen && (
        <AddParcelCategory
          open={addModalOpen}
          handleClose={handleClose}
          currentItems={selectedCategory}
          onSuccess={fetchAllData}
        />
      )}
    </>
  );
}

export default ParcelCategory;
